import { regex } from "react-admin";
import { apiService } from "../apiService";
import { CreateOrFixTaxNumberResult, FederalState } from "../GeneratedClients/FreeBillApi";

export const postCode = () => {
  return regex(/^\d{5}(?:[-\s]\d{4})?$/, 'Keine gültige Postleitzahl für Deutschland')
}

export const iban = () => {
  return regex(/[A-Z]{2}\d{2} ?\d{4} ?\d{4} ?\d{4} ?\d{4} ?[\d]{0,2}/, 'Keine gültige IBAN')
}

export const bic = () => {
  return regex(/[A-Z]{6,6}[A-Z2-9][A-NP-Z0-9]([A-Z0-9]{3,3}){0,1}/, 'Keine gültige BIC')
}

export const ustId = () => {
  return regex(/[A-Za-z]{2} ?\d[0-9]{8}/, 'Keine gültige UstId')
}

export const taxNumberAsync = async(value: string, allValues: any) => {
  var taxNumber = value
  var federalState: FederalState = allValues.federalState
  if(taxNumber && federalState) 
  {
    try {
      var {data: result} = await apiService.UsersApi.validateTaxNumber({taxNumber: taxNumber, federalState: federalState})
      return result === CreateOrFixTaxNumberResult.TaxNumberInvalid ? "Steuernummer ist ungültig" : undefined  
    } catch (error) {
      console.log(error)
      return "Fehler: Steuernummer kann nicht validiert werden"
    }
  }
  return undefined
}